import { z } from "zod";

import { PayexpressMethodType } from "@/data/payexpress/types/PayexpressMethodType";

export const PayexpressJobRequestApplicationDto = z
  .object({
    brokerFeeAmount: z.number().nullable(),
    brokerFeePercentage: z.number().nullable(),
    chosenPricingMethod: PayexpressMethodType.nullable(),

    finalRatePerHour: z.number().nullable(),
    localCompany: z.boolean().nullable(),

    payExpressFeeAmount: z.number().nullable(),
    payExpressFeePercentage: z.number().nullable(),

    paymentTerm: z.number().nullable(),
    vatRate: z.number().nullable(),
  })
  .passthrough();

export type PayexpressJobRequestApplicationDto = z.infer<typeof PayexpressJobRequestApplicationDto>;
